import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  Row,
  Col,
  InputGroup,
  Label,
  Container,
  CardBody,
  Card
} from "reactstrap";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";

import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { AvForm, AvField } from "availity-reactstrap-validation";
import {
  getMediaBuyerBudgetsById,
  getMediaBuyerDataForAdd,
  patchMediaBuyerBudget
} from "../../../../store/mediabuyers/mediabuyerbudget/actions";
import Select from "react-select";
import { setMediaBuyerBudgetsForId } from "../../../../store/mediabuyers/mediabuyerbudget/actions";

const EditMediaBuyerBudget = props => {
  const [mediaBuyerSelect, setMediaBuyerSelect] = React.useState(null);
  const [rangeDate, setRangeDate] = React.useState(null);

  let state = {
    isFormSubmit: false
  };

  React.useEffect(() => {
    const client_id = props.match.params.id;
    props.getMediaBuyerBudgetsById(client_id);
    props.getMediaBuyerDataForAdd();

    return () => {
      props.setMediaBuyerBudgetsForId(null);
      setMediaBuyerSelect(null);
      setRangeDate(null);
    }
  }, []);

  React.useEffect(() => {
    if (mediaBuyerSelect === null && props.client_budget !== null) {
        let inx = props.dataForAddBudget.mediaBuyers.findIndex(
          x => x.id === props.client_budget.media_buyer
        );
        setMediaBuyerSelect({
          label: props.dataForAddBudget.mediaBuyers[inx].number,
          value: props.dataForAddBudget.mediaBuyers[inx].id
        });
    }
    if (rangeDate === null) {
      props.client_budget &&
      setRangeDate({
        date: props.client_budget.date_range
      });
    } else {
      props.client_budget &&
      setRangeDate({
        date: props.client_budget.date_range
      });
    }
  }, [props.dataForAddBudget, props.client_budget]);

  const getMediaBuyers = item => {
    let media = [];
    item.mediaBuyers.map(i => {
      media.push({ label: i.number, value: i.id });
    });
    return media;
  };

  const onSubmitForm = (e, errors, params) => {
    state = { isFormSubmit: true };
    if (errors?.length === 0) {
      const offer_id = props.match.params.offerId;
      let data = {
        offer: offer_id,
        media_buyer: mediaBuyerSelect.value,
        budget: params.budget,
        date_range: rangeDate.date
      };
      const client_id = props.match.params.id;
      props.patchMediaBuyerBudget(client_id, data);
      return props.history.push(`/offers/${offer_id}#media-buyer-budgets`);
    }
  };

  return (
    <div className="page-content">
      {props.client_budget && (
        <Container fluid>
          <Breadcrumbs title="Media buyer budgets" breadcrumbItem={props.client_budget.media_buyer}
                       link="/media-buyer-budget"/>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <AvForm className="needs-validation" onSubmit={onSubmitForm}>
                    <Row>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label htmlFor="offer">Media buyer</Label>
                          <Select
                            name="mediaBuyer"
                            options={
                              props.dataForAddBudget !== null &&
                              getMediaBuyers(props.dataForAddBudget)
                            }
                            value={mediaBuyerSelect}
                            onChange={setMediaBuyerSelect}
                            required
                            isLoading={mediaBuyerSelect === null}
                            isFormSubmit={state.isFormSubmit}
                          />
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="mb-3">
                          <AvField
                            name="budget"
                            label="Budget"
                            type="number"
                            value={
                              props.client_budget &&
                              props.client_budget.budget.toString()
                            }
                            errorMessage="Invalid budget"
                            validate={{
                              required: { value: true },
                              minLength: {
                                value: 1,
                                errorMessage: "Min 1 number"
                              }
                            }}
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label>Date Range</Label>
                          <InputGroup>
                            <Flatpickr
                              name="date"
                              className="form-control d-block"
                              placeholder="dd M,yyyy"
                              value={rangeDate && rangeDate.date}
                              options={{
                                mode: "range",
                                dateFormat: "d-m-Y"
                              }}
                              style={{ backgroundColor: "white" }}
                              onChange={(date, dateStr) =>
                                setRangeDate({ date: dateStr })
                              }
                            />
                          </InputGroup>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <div className="text-end">
                          <button
                            type="submit"
                            className="btn btn-success save-user"
                          >
                            Save changes
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      )}
    </div>
  );
};

EditMediaBuyerBudget.propTypes = {
  history: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  getMediaBuyerBudgetsById: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  client_budget: PropTypes.object,
  getMediaBuyerDataForAdd: PropTypes.func.isRequired,
  dataForAddBudget: PropTypes.object,
  patchMediaBuyerBudget: PropTypes.func.isRequired,
  setMediaBuyerBudgetsForId: PropTypes.func.isRequired,
  offer: PropTypes.any
};

const mapStateToProps = state => ({
  data: state.MediaBuyerBudgets.data,
  client_budget: state.MediaBuyerBudgets.client_budget,
  dataForAddBudget: state.MediaBuyerBudgets.dataForAddBudget
});

export default connect(mapStateToProps, {
  getMediaBuyerBudgetsById,
  getMediaBuyerDataForAdd,
  patchMediaBuyerBudget,
  setMediaBuyerBudgetsForId
})(EditMediaBuyerBudget);
